/**
 * Index name used in Algolia
 */

const indexName = "media site"
module.exports = indexName
